import { Flex, Text } from '@mantine/core';
import { IconHeart } from 'ui-icons';

import { CardProps } from '../../../../DataDisplay';
import { PlaceholderCard } from '../PlaceholderCard/PlaceholderCard';
import classes from './AddCauseCard.module.css';

interface AddACauseCardProps extends CardProps {
  onClick?: () => void;
  isColumn?: boolean;
}

const AddACauseCard = ({ onClick, isColumn = false, ...props }: AddACauseCardProps) => {
  return (
    <PlaceholderCard
      onClick={onClick}
      className={classes.AddACauseCard}
      mod={{
        column: isColumn,
      }}
      {...props}
    >
      <Flex
        className={classes.AddACauseCard__group}
        direction={isColumn ? 'column' : 'row-reverse'}
      >
        <IconHeart className={classes.AddACauseCard__icon} />
        <Text className={classes.AddACauseCard__text}>Favorite a Cause</Text>
      </Flex>
    </PlaceholderCard>
  );
};

export { AddACauseCard };
